<section [class]="'sidenav'" [ngClass]="{'is--compressed': _toggleSideNav}">
  <!--pre-head-->
  <div [@logoAnimation]="(_toggleSideNav ? _toggleState.on : _toggleState.off)" class="prehead">
    <mat-icon svgIcon="logo-rebillia" [class]="'custom-mat-icon ico-logo-top'" [ngClass]="{'is--shrink' : _toggleSideNav, 'is--normal': !_toggleSideNav}"></mat-icon>
  </div>
  <!--head-->
  <div class="head">
    <div class="container">
      <button [@toggleButton]="(_toggleSideNav ? _toggleState.on : _toggleState.off)" (click)="showPanelShortcuts()" class="custom-mat-button button-add">
        <span class="icon-container">
          <mat-icon svgIcon="ico-add" class="custom-mat-icon ico"></mat-icon>
        </span>
        <span class="btn-txt">Add new</span>
      </button>
    </div>
  </div>
  <!--body-->
  <ul class="body">
    <!-- dashboard -->
    <a class="sidenav-link item-container" [routerLink]="['/main/dashboard']" routerLinkActive="router-link-active" matTooltip="Dashboard" matTooltipPosition="after" matTooltipClass="custom-mat-tooltip" [matTooltipDisabled]="!_toggleSideNav">
      <li [@toggleLink]="(_toggleSideNav ? _toggleState.on : _toggleState.off)" class="item">
        <span class="icon-container">
          <mat-icon matPrefix svgIcon="ico-dashboard" class="custom-mat-icon ico-sidenav ico-sidenav--dashboard ico-size ico-1xs"></mat-icon>
          <span *ngIf="notificationCount > 0 && notificationCount < 99" class="notification-ballon">{{notificationCount}}</span>
          <span *ngIf="notificationCount > 99" class="notification-ballon">!</span>
        </span>
        <span [@toggleLabel]="_toggleSideNav ? _toggleState.on : _toggleState.off" class="item-txt">Dashboard</span>
      </li>
    </a>
    <!-- subscriptions -->
    <a [class]="'sidenav-link item-container'" [ngClass]="{'option-active': _sideNavMenuOptionActive === _sideNavMenuOptions.subscriptions}" [routerLink]="['/main/subscriptions/list']" routerLinkActive="router-link-active" matTooltip="Subscriptions" matTooltipPosition="after" matTooltipClass="custom-mat-tooltip" [matTooltipDisabled]="!_toggleSideNav">
      <li class="item">
        <span class="icon-container">
          <mat-icon matPrefix svgIcon="ico-subscriptions" class="custom-mat-icon ico-sidenav ico-sidenav--subscriptions ico-size ico-xs"></mat-icon>
        </span>
        <span [@toggleLabel]="_toggleSideNav ? _toggleState.on : _toggleState.off" class="item-txt margin m0034">Subscriptions</span>
      </li>
    </a>
    <!-- products -->
    <a [class]="'sidenav-link item-container'" [ngClass]="{'option-active': _sideNavMenuOptionActive === _sideNavMenuOptions.products}" [routerLink]="['/main/products/list']" routerLinkActive="router-link-active" matTooltip="Products" matTooltipPosition="after" matTooltipClass="custom-mat-tooltip" [matTooltipDisabled]="!_toggleSideNav">
      <li class="item">
        <span class="icon-container">
          <mat-icon matPrefix svgIcon="ico-products" class="custom-mat-icon ico-sidenav ico-sidenav--products ico-size ico-xs"></mat-icon>
        </span>
        <span [@toggleLabel]="_toggleSideNav ? _toggleState.on : _toggleState.off" class="item-txt">Products</span>
      </li>
    </a>
    <!-- customers -->
    <a [class]="'sidenav-link item-container'" [ngClass]="{'option-active': _sideNavMenuOptionActive ===_sideNavMenuOptions.customer}" [routerLink]="['/main/customers/list']" routerLinkActive="router-link-active" matTooltip="Accounts" matTooltipPosition="after" matTooltipClass="custom-mat-tooltip" [matTooltipDisabled]="!_toggleSideNav">
      <li class="item">
        <span class="icon-container">
          <mat-icon matPrefix svgIcon="ico-customers" class="custom-mat-icon ico-sidenav ico-sidenav--customers ico-size ico-xs"></mat-icon>
        </span>
        <span [@toggleLabel]="_toggleSideNav ? _toggleState.on : _toggleState.off" class="item-txt">Accounts</span>
      </li>
    </a>
    <!-- invoices -->
    <a [class]="'sidenav-link item-container'" [ngClass]="{'option-active': _sideNavMenuOptionActive === _sideNavMenuOptions.invoices}" [routerLink]="['/main/invoices/list']" routerLinkActive="router-link-active" matTooltip="Invoices" matTooltipPosition="after" matTooltipClass="custom-mat-tooltip" [matTooltipDisabled]="!_toggleSideNav">
      <li class="item">
        <span class="icon-container">
          <mat-icon matPrefix svgIcon="ico-invoices" class="custom-mat-icon ico-sidenav ico-sidenav--invoices ico-size ico-xs"></mat-icon>
        </span>
        <span [@toggleLabel]="_toggleSideNav ? _toggleState.on : _toggleState.off" class="item-txt">Invoices</span>
      </li>
    </a>
    <!-- analytics -->
    <a [class]="'sidenav-link item-container'" [ngClass]="{'option-active': _sideNavMenuOptionActive === _sideNavMenuOptions.analytics}" [routerLink]="['/main/analytics']" routerLinkActive="router-link-active" matTooltip="Analytics" matTooltipPosition="after" matTooltipClass="custom-mat-tooltip" [matTooltipDisabled]="!_toggleSideNav">
      <li class="item">
        <span class="icon-container">
          <mat-icon matPrefix svgIcon="ico-analytics" class="custom-mat-icon ico-sidenav ico-sidenav--analytics ico-size ico-xs"></mat-icon>
        </span>
        <span [@toggleLabel]="_toggleSideNav ? _toggleState.on : _toggleState.off" class="item-txt">Analytics</span>
      </li>
    </a>
    <!-- transactions -->
    <a [class]="'sidenav-link item-container'" [ngClass]="{'option-active': _sideNavMenuOptionActive === _sideNavMenuOptions.transactions}" [routerLink]="['/main/transactions/list']" routerLinkActive="router-link-active" matTooltip="Transactions" matTooltipPosition="after" matTooltipClass="custom-mat-tooltip" [matTooltipDisabled]="!_toggleSideNav">
      <li class="item">
        <span class="icon-container">
          <mat-icon matPrefix svgIcon="ico-transactions" class="custom-mat-icon ico-sidenav ico-sidenav--transactions ico-size ico-xs"></mat-icon>
        </span>
        <span [@toggleLabel]="_toggleSideNav ? _toggleState.on : _toggleState.off" class="item-txt">Transactions</span>
      </li>
    </a>
    <!-- sales channels -->
    <a [class]="'sidenav-link item-container'" [ngClass]="{'option-active': _sideNavMenuOptionActive === _sideNavMenuOptions.integrations}" [routerLink]="['/main/integrations/sales-channels/list']" routerLinkActive="router-link-active" matTooltip="Sales Channels" matTooltipPosition="after" matTooltipClass="custom-mat-tooltip" [matTooltipDisabled]="!_toggleSideNav">
      <li class="item">
        <span class="icon-container">
          <mat-icon matPrefix svgIcon="ico-channels" class="custom-mat-icon ico-sidenav ico-sidenav--sales-channels ico-size ico-xs"></mat-icon>
        </span>
        <span [@toggleLabel]="_toggleSideNav ? _toggleState.on : _toggleState.off" class="item-txt">Sales channels</span>
      </li>
    </a>
    <!-- store setup -->
    <a [class]="'sidenav-link item-container'" [ngClass]="{'option-active': _sideNavMenuOptionActive === _sideNavMenuOptions.store}" [routerLink]="['/main/settings/store/store-profile']" routerLinkActive="router-link-active" matTooltip="Store Setup" matTooltipPosition="after" matTooltipClass="custom-mat-tooltip" [matTooltipDisabled]="!_toggleSideNav">
      <li class="item">
        <span class="icon-container">
          <mat-icon matPrefix svgIcon="ico-setup" class="custom-mat-icon ico-sidenav ico-sidenav--store-setup ico-size ico-xs"></mat-icon>
        </span>
        <span [@toggleLabel]="_toggleSideNav ? _toggleState.on : _toggleState.off" class="item-txt">Store setup</span>
      </li>
    </a>
  </ul>
  <!--footer-->
  <div class="footer">
    <div class="container">
      <button (click)="panelAccount.toggle()" class="button-account">
        <div class="avatar">
          <div class="avatar-background">
            <label class="label">{{ userInitials }}</label>
          </div>
        </div>
        <div class="user-info ">
          <label class="label-user-name">
            <span class="item-txt">Hi, {{userFirstName}}</span>
          </label>
          <label class="label-user-role">
            <span class="badge badge--user-role admin">{{userRole}}</span>
          </label>
        </div>
        <div class="icon-wrapper">
          <span class="icon-container">
            <mat-icon svgIcon="ico-next" class="custom-mat-icon ico ico-size ico-3xs"></mat-icon>
          </span>
        </div>
      </button>
    </div>
  </div>
  <panel-account #panelAccount [_toggleSideNav]="_toggleSideNav"></panel-account>
</section>
